module.exports = __webpack_public_path__ + "static/media/icon-next-enabled.223efa40.svg";